export default "__VITE_ASSET__BZrxRd3E__"